<template>
  <div class="planBase-detail-box">
    <plan-base-detail/>
  </div>
</template>

<script>
import PlanBaseDetail from '@/components/content/_mobile/plan/planBaseDetail'
export default {
  name: 'lordless-planBase-detail-page',
  components: {
    PlanBaseDetail
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_mobile/owner/_user/plan/baseDetail.vue